module.exports = __webpack_public_path__ + "static/media/existing_course.4e9a8465.svg";